<template>
  <div>
    <relatorio
      :headers="headersRel"
      :dados="relatorioList(relatorio)"
      :filtro-config="filtroConfig"
      :exportar-p-d-f="true"
      :exportar-x-l-s-x="true"
      @exportarPdf="exportPdf"
      @exportarXlsx="exportXlsx"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td
          v-if="item.produtor && item.produtor.length > 0"
          :colspan="headers.length"
        >
          <div>
            <v-simple-table
              dense
              class="mb-5 mt-5"
              style="border: 1px solid lightgrey; max-width: 92%;"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Setor</th>
                    <th style="width: 30%;">
                      Produtor/Fazenda
                    </th>
                    <th>Tipo</th>
                    <th>Serviço/Produto</th>
                    <th class="text-right">
                      Quantidade
                    </th>
                    <th class="text-right">
                      Valor Unitário
                    </th>
                    <th class="text-right">
                      Desconto
                    </th>
                    <th class="text-right">
                      Valor Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(itemRelacionado, index) in item.produtor"
                    :key="`${item.id}-${index}`"
                  >
                    <td v-if="itemRelacionado.data_atendimento">
                      {{ itemRelacionado.data_atendimento }}
                    </td>
                    <td v-else />

                    <td v-if="itemRelacionado.setor_descricao !== null && itemRelacionado.setor_descricao !== ''">
                      {{ itemRelacionado.setor_descricao }}
                    </td>
                    <td v-else />

                    <td v-if="itemRelacionado.produtor">
                      {{ `${itemRelacionado.produtor} - ${itemRelacionado.fazenda_nome}` }}
                    </td>
                    <td v-else />

                    <td>{{ itemRelacionado.tipo === 1 ? 'Produto' : 'Serviço' }}</td>
                    <td>{{ itemRelacionado.produto + (itemRelacionado.item_observacao ? ' - ' + itemRelacionado.item_observacao : '') }}</td>
                    <td class="text-right">
                      {{ currencyFormatter(itemRelacionado.quantidade) }}
                    </td>
                    <td class="text-right">
                      R$ {{ currencyFormatter(itemRelacionado.valor_unitario) }}
                    </td>
                    <td class="text-right">
                      R$ {{ currencyFormatter(itemRelacionado.valor_desconto) }}
                    </td>
                    <td class="text-right">
                      R$ {{ currencyFormatter(itemRelacionado.valor_total) }}
                    </td>
                  </tr>

                  <tr>
                    <td
                      colspan="8"
                      class="text-center font-weight-bold"
                    >
                      Total Técnico
                    </td>
                    <td class="font-weight-bold text-right">
                      R$ {{ currencyFormatter(item.total) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </td>
        <td
          v-else
          :colspan="headers.length"
        >
          Nenhum registro encontrado
        </td>
      </template>
    </relatorio>
  </div>
</template>

<script>
  import Relatorio from './Relatorio.vue'
  import { BOOTSTRAP_TECNICO_RELATORIO } from '@/store/modules/tecnicos'
  import { BOOTSTRAP } from '@/store/modules/relatorio'
  import JsPDF from 'jspdf'
  import moment from 'moment'
  import { mapState } from 'vuex'
  import { mapActions } from 'vuex/dist/vuex.common.js'
  import { currencyFormatter } from '../../utils/formatter'
  import { BOOTSTRAP_SETOR_RELATORIO } from '@/store/modules/setores'
  import XLSX from 'xlsx'
  import { BOOTSTRAP_SERVICOS_RELATORIO } from '@/store/modules/servicos'

  export default {
    components: {
      Relatorio,
    },
    data () {
      return {
        selecaoItem: null,
        currencyFormatter,
      }
    },
    computed: {
      ...mapState('relatorio', ['ready', 'relatorio', 'filtrosData']),
      ...mapState('tecnicos', ['ready', 'listTecnicos']),
      ...mapState('setores', ['setores']),
      ...mapState('servicos', ['listServicos']),
      headersRel () {
        return [
          { align: 'left', sortable: false, text: '', value: 'data-table-expand', width: '40px', report: false },
          { align: 'left', sortable: true, text: 'Técnico', value: 'tecnico', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, text: 'CPF', value: 'documento_tecnico', width: 'auto', floatingfilter: true, report: true },
        ]
      },
      filtroConfig () {
        return [
          ...(this.$store.state.user.roles[0].slug !== 'tecnico'
            ? [{
              filtro: 'tecnico',
              items: this.listTecnicos,
              itemText: 'nome',
              itemValue: 'id',
              label: 'Selecione um técnico',
              value: [],
            }] : []),
          {
            filtro: 'setor',
            items: this.setores,
            itemText: 'descricao',
            itemValue: 'id',
            label: 'Selecione um setor',
            value: [],
          },
          {
            filtro: 'servico',
            items: this.listServicos,
            itemText: 'nome',
            itemValue: 'id',
            label: 'Selecione um serviço',
            value: [],
          },

        ]
      },
    },
    mounted () {
      this.BOOTSTRAP_TECNICO_RELATORIO()
      this.BOOTSTRAP_SETOR_RELATORIO()
      this.BOOTSTRAP_SERVICOS_RELATORIO()
    },
    methods: {
      ...mapActions('tecnicos', [BOOTSTRAP_TECNICO_RELATORIO]),
      ...mapActions('relatorio', [BOOTSTRAP]),
      ...mapActions('setores', [BOOTSTRAP_SETOR_RELATORIO]),
      ...mapActions('servicos', [BOOTSTRAP_SERVICOS_RELATORIO]),
      relatorioList (produtoresTecnico) {
        if (!Array.isArray(produtoresTecnico)) return []

        return produtoresTecnico.map(tecnico => {
          let totalTecnico = 0
          const itensFlatten = []

          tecnico.produtor && Array.isArray(tecnico.produtor) && tecnico.produtor.forEach(produtor => {
            produtor.itens.forEach(item => {
              const valorTotal = Number(item.valor_total) || 0
              totalTecnico += valorTotal

              const dataFormatada = item.data_atendimento
                ? moment(item.data_atendimento).format('DD/MM/YYYY')
                : ''

              itensFlatten.push({
                data_atendimento: dataFormatada,
                setor_descricao: item.setor_descricao || '',
                produto: item.produto || '',
                quantidade: Number(item.quantidade) || 0,
                valor_unitario: Number(item.valor_unitario) || 0,
                valor_desconto: Number(item.valor_desconto) || 0,
                valor_total: Number(item.valor_total) || 0,
                item_observacao: item.item_observacao,
                tipo: Number(item.tipo),
                produtor: produtor.produtor,
                fazenda_nome: produtor.fazenda_nome,
              })
            })
          })

          return {
            id: tecnico.id,
            tecnico: tecnico.tecnico,
            documento_tecnico: tecnico.documento_tecnico,
            produtor: itensFlatten,
            total: totalTecnico,
          }
        })
      },

      async exportXlsx () {
        const dados = this.relatorioList(this.relatorio)

        const wb = XLSX.utils.book_new()
        const ws_data = []

        if (dados.length > 0) {
          let valor_total_geral = 0
          dados.forEach((dado, index) => {
            const headers = []
            const dadosHeaders = []

            headers.push('Técnico', 'CPF')
            dadosHeaders.push(dado.tecnico, dado.documento_tecnico)

            ws_data.push(headers)
            ws_data.push(dadosHeaders)
            let total_tecnico = 0
            ws_data.push(['Data', 'Setor', 'Produtor/Fazenda', 'Tipo', 'Serviço/Produto', 'Quantidade', 'Valor Unitário', 'Desconto', 'Valor Total'])
            dado.produtor.forEach(item => {
              valor_total_geral += item.valor_total
              ws_data.push([
                item.data_atendimento,
                item.setor_descricao,
                item.produtor ? item.produtor + ' - ' + item.fazenda_nome : '',
                item.tipo === 1 ? 'Produto' : 'Serviço',
                item.produto,
                { v: parseFloat(item.quantidade, 0), t: 'n', s: { alignment: { horizontal: 'rigth' } } },
                { v: parseFloat(item.valor_unitario, 2), t: 'n', s: { alignment: { horizontal: 'right' } } },
                { v: parseFloat(item.valor_desconto, 2), t: 'n', s: { alignment: { horizontal: 'right' } } },
                { v: parseFloat(item.valor_total, 2), t: 'n', s: { alignment: { horizontal: 'rigth' } } },
              ])
              total_tecnico += parseFloat(item.valor_total)
            })
            ws_data.push(['', '', '', '', '', '', '', 'Total Técnico', { v: total_tecnico, t: 'n', s: { alignment: { horizontal: 'right' } } }])
            if (index === dados.length - 1) {
              ws_data.push(['', '', '', '', '', '', '', 'Total Geral', { v: parseFloat(valor_total_geral, 2), t: 'n', s: { alignment: { horizontal: 'right' } } }])
            }
            ws_data.push(['', '', ''])
          })
        } else {
          ws_data.push(['Técnico', 'CPF'])
          ws_data.push(['', '', ''])
          ws_data.push(['Data', 'Setor', 'Produtor/Fazenda', 'Tipo', 'Serviço/Produto', 'Quantidade', 'Valor Unitário', 'Desconto', 'Valor Total'])
          ws_data.push(['', '', ''])
        }

        const ws = XLSX.utils.aoa_to_sheet(ws_data)

        const colWidths = ws_data[0].map((_, colIndex) => {
          return ws_data.reduce((maxWidth, currentRow) => {
            let cellValue = currentRow[colIndex]

            if (cellValue && typeof cellValue === 'object' && cellValue.v !== undefined) {
              cellValue = cellValue.v.toString()
            } else if (cellValue === null || cellValue === undefined) {
              cellValue = ''
            } else {
              cellValue = cellValue.toString()
            }

            const cellWidth = cellValue.length
            return Math.max(maxWidth, cellWidth)
          }, 0)
        })

        ws['!cols'] = colWidths.map(width => ({ wch: Math.min(Math.max(width + 2, 8), 50) }))
        XLSX.utils.book_append_sheet(wb, ws, 'Relatório')
        XLSX.writeFile(wb, 'Relatorio.xlsx')
      },
      async exportPdf () {
        const dados = this.relatorioList(this.relatorio)
        let pageNumberAtual = 0

        var doc = new JsPDF({
          orientation: 'portrait',
        })
        var totalPagesExp = '{total_pages_count_string}'

        const docWidth = doc.internal.pageSize.width
        const docHeight = doc.internal.pageSize.height
        const logo = await loadImageAsBase64(window.location.origin + '/img/logo.png')

        const margin = { left: 10, right: 10, bottom: 10 }
        const dateNow = moment().format('DD/MM/YYYY')
        const horaNow = moment().format('HH:mm:ss')

        function addFooter () {
          doc.text(dateNow, 12, docHeight - 10)
          doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - margin.bottom, { align: 'center' })
        }

        function addHeader (name, logo, doc, data_inicial, data_final, pageNumber) {
          if (pageNumber === pageNumberAtual) return true
          doc.addImage(logo, 'png', 10, 5, 42, 12.16)
          doc.setFontSize(16)
          doc.text(name, docWidth / 2, 15, { align: 'center' })
          doc.setFontSize(8)
          doc.text(dateNow, docWidth - 10, 15, { align: 'right' })
          doc.text(horaNow, docWidth - 10, 20, { align: 'right' })
          doc.setFontSize(10)
          doc.line(margin.left, 23, docWidth - margin.right, 23)
          doc.text(
            `Período de:${moment(data_inicial).format('DD/MM/YYYY')} até ${moment(data_final).format('DD/MM/YYYY')}`,
            12,
            27,
            { align: 'left' },
          )
          doc.line(margin.left, 28, docWidth - margin.right, 28)
          doc.autoTable({
            startY: 28,
            theme: 'plain',
            styles: { fontSize: 8, fontStyle: 'bold', margin: { top: 0, bottom: 0, left: 1, right: 1 } },
            margin: { left: margin.left, right: margin.right },
            body: [
              [
                { content: 'Data', styles: { cellWidth: 11, lineColor: [0, 0, 0], lineWidth: { bottom: 0.2 } } },
                { content: 'Setor', styles: { cellWidth: 16, lineColor: [0, 0, 0], lineWidth: { bottom: 0.2 } } },
                { content: 'Produtor/Fazenda', styles: { cellWidth: 72, lineColor: [0, 0, 0], lineWidth: { bottom: 0.2 } } },
                { content: 'Serviço/Produto', styles: { cellWidth: 36, lineColor: [0, 0, 0], lineWidth: { bottom: 0.2 } } },
                { content: 'Qtde.', styles: { cellWidth: 14, lineColor: [0, 0, 0], lineWidth: { bottom: 0.2 } } },
                { content: 'Vlr.', styles: { cellWidth: 14, lineColor: [0, 0, 0], lineWidth: { bottom: 0.2 } } },
                { content: 'Desc.', styles: { cellWidth: 14, lineColor: [0, 0, 0], lineWidth: { bottom: 0.2 } } },
                { content: 'Total', styles: { cellWidth: 13, lineColor: [0, 0, 0], lineWidth: { bottom: 0.2 } } },
              ],
            ],
            columnStyles: {
              0: { halign: 'left' },
              1: { halign: 'left' },
              2: { halign: 'left' },
              3: { halign: 'left' },
              4: { halign: 'right' },
              5: { halign: 'right' },
              6: { halign: 'right' },
              7: { halign: 'right' },
            },
          })
          pageNumberAtual = pageNumber
          return false
        }

        async function loadImageAsBase64 (url) {
          const response = await fetch(url)
          const blob = await response.blob()

          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          })
        }

        let startY = 36.5

        let valor_total_geral = 0
        dados.forEach((item, index) => {
          const bodyItems = []

          if (item.produtor && item.produtor.length > 0) {
            item.produtor.forEach(itemRelacionado => {
              valor_total_geral += itemRelacionado.valor_total
              bodyItems.push({
                data_atendimento: itemRelacionado.data_atendimento || '',
                setor_descricao: itemRelacionado.setor_descricao || '',
                produtor: itemRelacionado.produtor ? `${itemRelacionado.produtor} - ${itemRelacionado.fazenda_nome}` : '',
                produto: itemRelacionado.produto ? itemRelacionado.produto + (itemRelacionado.item_observacao ? ' - ' + itemRelacionado.item_observacao : '') : '',
                quantidade: itemRelacionado.quantidade || 0,
                valor_unitario: itemRelacionado.valor_unitario || 0,
                desconto: itemRelacionado.valor_desconto || 0,
                valor_total: itemRelacionado.valor_total || 0,
                tipo: itemRelacionado.tipo || 2,
              })
            })
          }
          bodyItems.push([
            { content: 'Total do técnico:', styles: { fontStyle: 'bold', halign: 'center' }, colSpan: 7 },
            { content: item.total, styles: { fontStyle: 'bold', halign: 'right' } },
          ])

          if (index === this.relatorio.length - 1) {
            bodyItems.push([
              {
                content: 'Total Geral',
                colSpan: 6,
                styles: {
                  fontStyle: 'bold',
                  halign: 'right',
                  lineColor: [0, 0, 0],
                },
              },
              {
                content: Number(valor_total_geral),
                colSpan: 2,
                styles: {
                  fontStyle: 'bold',
                  halign: 'right',
                  lineColor: [0, 0, 0],
                },
              },
            ])
          }

          if (pageNumberAtual > 0) doc.line(margin.left, startY - 1, docWidth - margin.right, startY - 1)

          doc.autoTable({
            theme: 'plain',
            startY: startY,
            margin: { left: margin.left, bottom: 20 },
            styles: {
              textColor: 20,
              fillColor: [255, 255, 255],
              cellPadding: { top: 0, right: 5, bottom: 0, left: 0 },
              fontSize: 10,
              minCellHeight: 5,
            },
            columnStyles: {
              0: {
                cellWidth: 'auto',
                halign: 'left',
              },
              1: {
                cellWidth: 76,
                halign: 'left',
              },
            },
            body: [
              [
                { content: `Nome: ${item.tecnico}`, styles: { cellPadding: { left: 0 } } },
                { content: `CPF: ${item.documento_tecnico}` },
              ],
            ],
          })

          startY = doc.previousAutoTable.finalY + 1
          doc.line(margin.left, startY - 1, docWidth - margin.right, startY - 1)

          if (bodyItems.length > 0) {
            doc.autoTable({
              theme: 'plain',
              startY: startY,
              margin: { top: 36.6, left: margin.left, right: margin.right },
              styles: {
                textColor: 20,
                fillColor: [255, 255, 255],
                cellPadding: { top: 0, right: 1, bottom: 0, left: 1 },
                fontSize: 5,
                minCellHeight: 4,
              },
              columns: [
                { dataKey: 'data_atendimento' },
                { dataKey: 'setor_descricao' },
                { dataKey: 'produtor' },
                { dataKey: 'produto' },
                { dataKey: 'quantidade' },
                { dataKey: 'valor_unitario' },
                { dataKey: 'desconto' },
                { dataKey: 'valor_total' },
              ],
              columnStyles: {
                data_atendimento: { cellWidth: 11, halign: 'left' },
                setor_descricao: { cellWidth: 16, halign: 'left', overflow: 'ellipsize' },
                produtor: { cellWidth: 72, halign: 'left', overflow: 'ellipsize' },
                produto: { cellWidth: 36, halign: 'left' },
                quantidade: { cellWidth: 14, halign: 'right' },
                valor_unitario: { cellWidth: 14, halign: 'right' },
                desconto: { cellWidth: 14, halign: 'right' },
                valor_total: { cellWidth: 14, halign: 'right' },
              },
              body: [
                ...bodyItems,

              ],
              didParseCell: function (data) {
                const number = data.column.dataKey === 'valor_unitario' || data.column.dataKey === 'quantidade' || data.column.dataKey === 'desconto' || data.column.dataKey === 'valor_total'
                if (data.section !== 'head' && number) {
                  data.cell.text[0] = currencyFormatter(data.cell.text[0])
                  data.cell.styles.halign = 'right'
                }
              },
              didDrawPage: (data) => {
                const retorno = addHeader('Serviços por técnico', logo, doc, this.filtrosData.data_inicial, this.filtrosData.data_final, data.pageNumber)
                if (retorno) return
                var str = 'Página ' + doc.internal.getNumberOfPages()
                if (typeof doc.putTotalPages === 'function') {
                  str = str + ' / ' + totalPagesExp
                }
                doc.setFontSize(10)
                doc.text(str, docWidth + 27.5, docHeight - 10, { align: 'right' })

                addFooter()
              },
            })

            startY = doc.previousAutoTable.finalY + 5
          }
        })

        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp)
        }

        doc.save('Serviços por técnico.pdf')
      },
      calcTotalTecnico (tecnico) {
        return tecnico.produtor.reduce((total, item) => {
          return total + this.calcTotalProdutor(item)
        }, 0)
      },
      calcTotalProdutor (produtor) {
        return produtor.itens.reduce((total, item) => {
          return total + (parseFloat(item.valor_total) || 0)
        }, 0)
      },
    },
  }
</script>
